module.exports = __webpack_public_path__ + "img/ar-sector-navigate.fa08568b.svg";